export default "__VITE_ASSET__COkx1jiJ__"